import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import styles from '../shared/styles';
import Audioplayer from './Audioplayer';

class Audioplayback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      original: props.original,
      edited: props.edited,
    };
  }

  render() {
    const { published, publicEpisode } = this.props;
    const { original, edited } = this.state;
    const playbacks = [{
      statekey: 'original',
      value: original,
      title: 'Original audio',
      show: !isEmpty(original),
    }, {
      statekey: 'edited',
      value: edited,
      title: 'Processed audio',
      show: !isEmpty(edited) && !published,
    }];

    return (
      <div className="row" style={styles.rowDivision}>
        <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <div>
            <div className="row">
              {playbacks.map((playback, index) => {
                if (!playback.show) {
                  return null;
                }

                return (
                  <div key={`playback-${index}`} className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <div style={styles.playbackWrapper}>
                      <Audioplayer
                        label={playback.title}
                        source={playback.value}
                        public={publicEpisode}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Audioplayback.propTypes = {
  original: PropTypes.string,
  edited: PropTypes.string,
  published: PropTypes.bool,
  publicEpisode: PropTypes.bool,
};

Audioplayback.defaultProps = {
  original: '',
  edited: '',
  published: false,
  publicEpisode: false,
};

export default Audioplayback;
